import { useEffect } from "react";

export interface DialogParams {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  /** Disable backdrop-click/Escape close, e.g. while a mutation is in flight. Default true. */
  closeOnBackdrop?: boolean;
}

export const Dialog = ({
  children,
  isOpen,
  onClose,
  closeOnBackdrop = true,
}: DialogParams) => {
  useEffect(() => {
    if (!isOpen || !closeOnBackdrop) return;

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isOpen, closeOnBackdrop, onClose]);

  if (!isOpen) return null;

  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (closeOnBackdrop && e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black/70 backdrop-blur-xs flex items-center justify-center z-100"
      id="dialog-container"
      onClick={handleBackdropClick}
    >
      {children}
    </div>
  );
};
